import script from "./ProjectCompletenessReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCompletenessReport.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCompletenessReport.vue?vue&type=style&index=0&id=dd50537c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd50537c"]])

export default __exports__